import { useCallback } from 'react';

import { callHostFunction } from '@src/common/hostCallbacks';
import { useAppSelector, useWidgetParam } from '@src/core/hooks';
import { buyerSelector } from '@src/features/customers';
import { getOrderAnalyticsData, toSellerTemplateOrder, type Order } from '@src/features/orders';
import { track } from '@src/services/analytics';

/**
 * What the embedding page and analytics expect when a purchase completes. The legacy checkout
 * fired both on every mode change with a confirmed order; here the caller guarantees one call
 * per completed order.
 */
export const useCheckoutHostCallbacks = () => {
  const onSaleCompletion = useWidgetParam('on-sale-completion');
  const [buyer] = useAppSelector(buyerSelector);

  return useCallback(
    (order: Order) => {
      track('checkoutCompleted', getOrderAnalyticsData(order));
      callHostFunction(onSaleCompletion, toSellerTemplateOrder(order), buyer);
    },
    [onSaleCompletion, buyer],
  );
};

export default useCheckoutHostCallbacks;
